/**
 * userpreferencesaction.js
 * Created by calhosh on 8/28/2020.
 */
import * as types from '../actiontypes';
import {promiseAreas} from './../../util/uiconstants';
export function getUserPreferences(url, resource) {
	return {
		type: types.GET_USER_PREFERENCES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource},
				trackWithArea: promiseAreas.USER_SETTINGS_AREA
			}
		}
	};
}

export function setUserPreferences(url, resource) {
	return {
		type: types.SET_USER_PREFERENCES,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource,
				trackWithArea: promiseAreas.USER_SETTINGS_AREA
			}
		},
		theme: resource?.theme
	};
}

export function createUserPreferences(url, resource) {
	return {
		type: types.CREATE_USER_PREFERENCES,
		meta: {
			api: {
				url,
				method: 'POST',
				data: resource,
				trackWithArea: promiseAreas.USER_SETTINGS_AREA
			}
		},
		theme: resource?.theme
	};
}

export function getTimezones(url, resource) {
	return {
		type: types.GET_TIMEZONES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}
export function setDelegateActiveTab(tab) {
	return {
		type: types.SET_DELEGATE_ACTIVE_TAB,
		tab
	};
}

export function setUserTheme(themeisDark) {
	return {
		type: types.SET_USER_THEME,
		isDark: themeisDark
	};
}
